import { gql } from "@apollo/client";

import MeetingViewMeetingNodeNewPageFragment from "@apps/meeting-new/graphql/meeting-view-meeting-node-fragment";

export default gql`
  ${MeetingViewMeetingNodeNewPageFragment}
  query getMeetingForExtensionQuery($meetingId: Int!) {
    meeting(meetingId: $meetingId) {
      ...MeetingViewMeetingNodeNewPageFragment
    }
  }
`;
